import { render } from "./TestTorchView.vue?vue&type=template&id=edac3092&scoped=true&lang=true"
import script from "./TestTorchView.vue?vue&type=script&lang=js"
export * from "./TestTorchView.vue?vue&type=script&lang=js"

import "./TestTorchView.vue?vue&type=style&index=0&id=edac3092&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edac3092"]])

export default __exports__